import { PropsWithChildren } from 'react';
import { Button } from 'src/common/Button/Button';
import { CalcIcon } from 'src/modules/common/icons/CalcIcon';

type Props = PropsWithChildren<{
    onClick?: () => void;
}>;

export const CalculatorInputRow = ({ children, onClick }: Props) => (
    <div className="vss-calculator-input-row">
        {onClick && (
            <Button
                data-testid="calculator-input-row-button"
                className="vss-calculator-input-row__button"
                iconOnly={true}
                size="md"
                onClick={onClick}
                kind="secondary"
            >
                <CalcIcon/>
            </Button>
        )}

        {children}
    </div>
);
